var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal-card',{attrs:{"title":_vm.title}},[_c('site-change-snapshot',{attrs:{"site-id":_vm.siteId,"change-id":_vm.changeId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }